import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from '../../theme/ThemeContext';
import { CheckIcon, CloseIcon, ActivityIcon } from '../../helpers/Icons';
import { selectToasts, removeToast } from '../../redux/features/platformSlice';

export const ToastContainer = () => {
  const toasts = useSelector(selectToasts);
  const theme = useTheme();

  return (
    <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 10000, display: 'flex', flexDirection: 'column', gap: 10 }}>
      {toasts.map(t => (
        <ToastItem key={t.id} toast={t} theme={theme} />
      ))}
      <style>{`
        @keyframes toast-in {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

const ToastItem = ({ toast, theme }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(removeToast(toast.id));
    }, toast.duration || 3000);
    return () => clearTimeout(timer);
  }, [dispatch, toast.duration, toast.id]);

  return (
    <div style={{
      background: theme.card,
      border: `1px solid ${theme.border}`,
      padding: '12px 16px',
      borderRadius: 8,
      color: theme.text,
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      minWidth: 200,
      animation: 'toast-in 0.3s ease-out',
    }}>
      {toast.type === 'success' ? <CheckIcon s={16} c={theme.pos} /> :
       toast.type === 'error' ? <CloseIcon s={16} c={theme.neg} /> :
       <ActivityIcon s={16} c={theme.primary} />}
      <span style={{ fontSize: 12, fontWeight: 600 }}>{toast.message}</span>
    </div>
  );
};
